export const formatCamelCase = (text) => {
  if (!text) return "";

  // Insert a space before each capital letter
  const formatted = text.replace(/([A-Z])/g, " $1");

  // Capitalize the first letter
  return formatted.charAt(0).toUpperCase() + formatted.slice(1).toLowerCase();
};